export const activityJson = {
  medium: "",
  eventId: "",
  r11: "",
  r12: "",
  r13: "",
  r14: "",
  r15: "",
  r21: "",
  r22: "",
  r23: "",
  r24: "",
  r25: "",
  r31: "",
  r32: "",
  r33: "",
  r34: "",
  r35: "",
  r41: "",
  r42: "",
  r43: "",
  r44: "",
  r45: "",
  preferreddegree: "",
  preferredcountry: "",
  preferredfield: "",
  preferredintake: "",
  preferredyear: "",
  financialsource: "",
  workexperience: "NO",
  yearsexperience: "",
  testgiven: "No",
  testscore: "",
  testname: "",
  visastatus: "No",
  visaelaborate: "",
  howyouheardaboutus: "",
};

export const activityJson2 = {
  medium: "",
  eventId: "",
  // 12th Details
  board: "",
  passingYear12: "",
  stream: "",
  percentage12: "",

  // Bachelor's Details
  universityUG: "",
  passingYearUG: "",
  subjectUG: "",
  percentageUG: "",

  // Master's Details
  universityPG: "",
  passingYearPG: "",
  subjectPG: "",
  percentagePG: "",

  // Preferences
  preferredDegree: "", // heardFrom,preferredDegree,preferredCountry
  preferredDegreeOther: "",
  preferredCountry: [],
  preferredField: "",
  preferredIntake: "",
  preferredIntakeYear: "",

  // Additional Information
  workExperience: "",
  givenTest: "",
  testName: "",
  heardFrom: [], 
  otherComments: "",
  recommendedCountry: [],
  contact_Type:""
};
